const cartOverlay = document.querySelector('.cart__overlay');

function showCartOverlay() {
  cartOverlay.classList.remove('hidden');
  void cartOverlay.offsetWidth;
  cartOverlay.classList.add('active');
}

function hideCartOverlay() {
  cartOverlay.classList.remove('active')
  setTimeout(() => {
    cartOverlay.classList.add('hidden');
  }, 300);
}

const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

function showErrorNotification() {
  const el = document.getElementById("notification-banner__holder");
  if (!el) return;
  el.classList.add("show");
  clearTimeout(el.hideTimeout);
  el.hideTimeout = setTimeout(() => {
    hideCartError();
  }, 4000);
}

function hideCartError() {
  const el = document.getElementById("notification-banner__holder");
  if (!el) return;
  el.classList.remove("show");
}

function initGallery(
  galleryImageList, 
  items, 
  galleryBtnPrevious, 
  galleryBtnNext, 
  dotsContainer
) {

  galleryBtnPrevious.addEventListener('click', function (event) {
    go(-1)
  });

  galleryBtnNext.addEventListener('click', function (event) {
    go(1)
  });

  items.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = "shared__dot"
    dot.addEventListener('click', () => {
      items[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
    dotsContainer.appendChild(dot);
  });

  const dots = Array.from(dotsContainer.querySelectorAll('button'));

  function setActiveDot(index) {
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }

  function getCurrentIndex() {
    const padLeft = parseFloat(getComputedStyle(galleryImageList).scrollPaddingLeft) || 0;
    const left = galleryImageList.scrollLeft;
    let best = 0, bestDelta = Infinity;
    items.forEach((el, i) => {
      const targetLeft = el.offsetLeft - padLeft;
      const delta = Math.abs(targetLeft - left);
      if (delta < bestDelta) { best = i; bestDelta = delta; }
    });
    return best;
  }

  function go(dir) {
    const i = getCurrentIndex();
    const target = Math.max(0, Math.min(items.length - 1, i + dir));
    // Let scroll snapping + padding handle the alignment
    items[target].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function updateDisabled() {
    const i = getCurrentIndex();
    galleryBtnPrevious.disabled = i === 0;
    galleryBtnNext.disabled = i === items.length - 1;
  }

  galleryImageList.addEventListener('scroll', () => {
    requestAnimationFrame(() => {
      updateDisabled();                      // enable/disable prev/next
      setActiveDot(getCurrentIndex());       // highlight correct dot
    });
  });

  window.addEventListener('resize', updateDisabled);
  updateDisabled();
  setActiveDot(0);
}

document.addEventListener('DOMContentLoaded', function() {
  
  const cartToggle = document.getElementById('cart-toggle'); // Navbar button
  const cartClose = document.getElementById('cart-close');   // Close button inside cart
  const cartContainer = document.querySelector('.cart__slider-container');

  // Open cart when clicking the navbar cart button
  cartToggle.addEventListener('click', function(event) {
    event.stopPropagation();
    cartContainer.classList.add('active');
    showCartOverlay()
  });

  cartOverlay.addEventListener('click', function(event) {
    cartContainer.classList.remove('active')
    hideCartOverlay()
  });

  // Close cart when clicking the close button inside cart
  cartClose.addEventListener('click', function(event) {
    event.stopPropagation();
    cartContainer.classList.remove('active');
    hideCartOverlay()
  });
  
  // Close cart when clicking outside the cart slider
  // document.addEventListener('click', function(event) {
  //   const isClickInsideCart = cartContainer.contains(event.target);
  //   const isClickOnToggle = cartToggle.contains(event.target);
  //   if (!isClickInsideCart && !isClickOnToggle) {
  //     cartContainer.classList.remove('active');
  //   }
  // });
});


document.querySelectorAll(".feat-reviews__review-item").forEach(container => {

  const video = container.querySelector(".feat-reviews__review-item-video");
  const btn = container.querySelector(".feat-reviews__video-play-pause-btn");
  const benefits = container.querySelector(".product__benefits-holder")

  if (btn) {
    btn.addEventListener("click", () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

  if (video) {
    video.addEventListener("play", () => {
      video.setAttribute("controls", "");
      btn.style.display = "none";
      benefits.style.display = "none";
    });
    video.addEventListener("pause", () => {
      btn.textContent = "▶";
      video.removeAttribute("controls");
      btn.style.display = "flex";
      benefits.style.display = "flex";
    });
  }
});